import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { isPlatformServer } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SsrPreloadGuard implements CanActivate {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  canActivate(): boolean {
    //console.log('SSR Guard - isPlatformServer:', isPlatformServer(this.platformId));
    return true;
  }
}
